module.exports = "/**\r\n * 左侧的 markdown 看起来并不美观。\r\n *\r\n * 我们稍作修饰。\r\n */\r\n\r\n#work-text {\r\n  max-height: 94.5%;\r\n}\r\n\r\n#work-text.flipped {\r\n  -webkit-transform: rotateX(0deg) rotateY(190deg) rotateZ(180deg);\r\n}\r\n\r\n#work-text .md {\r\n  -webkit-transform: rotateY(190deg) rotateZ(180deg);\r\n  margin-top: 1200px;\r\n}\r\n\r\n/**\r\n * 下面就是见证奇迹的时刻：\r\n *\r\n * 3。\r\n * 2。\r\n * 1。\r\n *\r\n * 。\r\n * 骗你啦，啥也没有~\r\n *\r\n * 好吧，其实是有的，来了。\r\n *\r\n */\r\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/components/style-text/styles1.css
// module id = UXP2
// module chunks = 1